var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { memo, useMemo, useState } from 'react';
import { RewardType } from 'root/src/shared/rewards/constants';
import { KeyProductMnemonicIdResolver, } from 'root/src/shared/rewards/services/productResolver.service';
import getBountyName from 'root/src/shared/util/getBountyName';
import { useClipboard } from 'root/src/client/web/hooks/useClipboard';
import Link from 'root/src/client/web/base/Link';
import { PasswordInput } from 'root/src/client/v2/auth/components/PasswordInput';
import toast from 'react-hot-toast';
import ClipboardIcon from 'root/src/client/public/icons/ic-clipboard-2.svg';
import { CopyToClipboardBase } from 'root/src/client/web/base/CopyToClipboardBase';
import { addHttpsProtocol } from 'root/src/shared/util/protocolUtil';
import { useModal } from 'root/src/client/v2/common/contexts/modal.context';
import { ModalLayout } from 'root/src/client/v2/common/layouts/ModalLayout';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { ButtonNew } from 'root/src/client/v2/common/components/form/ButtonNew';
export const InitialProductDisplayModal = memo((props) => {
    const { dropEvent, products = [], dare } = props;
    const [isAgreed, setIsAgreed] = useState(false);
    const shortUrl = addHttpsProtocol(props.shortUrl);
    const modal = useModal();
    return (<ModalLayout className="sm:min-w-[600px]">
			<form onSubmit={(event) => {
            event.preventDefault();
            modal.hide();
        }}>
				<div className="flex flex-col justify-center items-center gap-4">
					<Heading />
					<Dare dare={dare}/>
					<Spacer />
					<Products products={products} shortUrl={shortUrl} isGameFree={dropEvent.isGameFree}/>
					<ShortUrl shortUrl={shortUrl}/>
					<FormControlLabel control={(<Checkbox checked={isAgreed} onChange={(_, isChecked) => {
                setIsAgreed(isChecked);
            }}/>)} label={(<span className="text-sm">
								I agree to post this link with my content
							</span>)}/>
					<ButtonNew type="submit" disabled={!isAgreed} className="font-bold uppercase text-center">
						Continue
					</ButtonNew>
				</div>
			</form>
		</ModalLayout>);
});
const Dare = memo((props) => {
    const { dare } = props;
    const game = dare.games[0];
    const dareProductRegion = useMemo(() => {
        if (dare.product.type === RewardType.KEY) {
            return new KeyProductMnemonicIdResolver(dare.product.id).getReadableRegion();
        }
        return 'Worldwide';
    }, [dare]);
    return (<div className="flex flex-col justify-center items-center gap-4">
			<img src={game.image} alt={game.label} className="w-36 h-48"/>
			<div className="flex justify-between gap-12">
				<div className="flex gap-1">
					<span className="text-light-5 uppercase text-2xs">Level:</span>
					<span className="uppercase text-2xs">{dare.level}</span>
				</div>
			</div>
			<div className="flex flex-col gap-1 justify-center items-center">
				<span className="text-light-5 uppercase text-2xs text-center">
					Loot for your fans:
				</span>
				<span className="text-light-5 text-sm text-center">
					{getBountyName({
            name: dare.product.name,
            type: dare.product.type,
            amount: dare.amount,
        }, false)}
				</span>
			</div>
			<div className="flex flex-col justify-center items-center gap-2">
				<span className="bg-dark-1 text-light-3 rounded px-6 py-1 text-xs">
					{dareProductRegion}
				</span>
				<span className="text-sm font-medium">{dare.title}</span>
			</div>
		</div>);
});
const Spacer = memo(() => {
    return <div className="flex w-1/3 h-[1px] bg-white flex-initial"/>;
});
const Heading = memo(() => {
    return (<div className="flex flex-col justify-center items-center gap-1">
			<h1 className="font-bold text-2xl text-center">Ready player one?</h1>
			<span className="text-center text-light-4 font-medium text-2xs">
				Your key is below. Copy the key to your clipboard and head
				<br />
				on over to Steam and complete the Dare!
			</span>
		</div>);
});
const Products = memo((props) => {
    const { products, shortUrl, isGameFree } = props;
    const { writeText } = useClipboard();
    if (!products.length) {
        return (<div className="flex flex-col justify-center items-center gap-2">
				<span className="text-center">No initial key for this drop</span>
				<Link href={shortUrl}>
					{isGameFree ? 'Free to play' : 'Get the game here to dare'}
				</Link>
			</div>);
    }
    return (<ul className="flex flex-col w-full gap-6">
			{products.map((product) => {
            return (<li className="flex w-full flex-col justify-center items-center gap-2 relative">
						<PasswordInput key={product.name} label={product.name} value={product.rewardData} aria-readonly="true" InputProps={{
                    readOnly: true,
                }}/>
						<button type="button" className="absolute -right-14 bg-light-3 rounded px-3 py-1.5 border-2 border-light-5" onClick={() => __awaiter(void 0, void 0, void 0, function* () {
                    yield writeText(product.rewardData);
                    toast.success('Key copied to clipboard');
                })}>
							<img src={ClipboardIcon.src} alt="Clipboard"/>
						</button>
					</li>);
        })}
		</ul>);
});
const ShortUrl = memo((props) => {
    const { shortUrl } = props;
    return (<CopyToClipboardBase onCopied={() => {
            toast.success('Link copied to clipboard');
        }} text={shortUrl}>
			<div className="flex flex-col gap-2 justify-center items-center">
				<img className="w-6 h-6" src={ClipboardIcon.src} alt="Clipboard"/>
				<p className="text-teal uppercase text-sm text-center">Copy game link to clipboard</p>
			</div>
		</CopyToClipboardBase>);
});
